import { fetchEspAccountsQuery } from 'api/queries/espAccounts';
import { MESSAGE_MEDIUMS, WhatsApp } from 'constants/messageMediums';
import { EspAccount } from 'modules/graphql/types';
import {
  EMAIL_SERVICE_PROVIDERS,
  SMS_SERVICE_PROVIDERS,
  WHATS_APP_SERVICE_PROVIDERS,
} from 'modules/sendingPlatforms/constants';
import { addNegativeToastWithErrorId } from 'modules/toastContainer';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useGraphql } from 'utils/hooks/useGraphql';
import { getMediumByKey } from 'utils/messageMediums';

export type FetchEspAccountsResponse = {
  espAccounts: EspAccount[];
};

export const useEspAccounts = (messageMedium: string) => {
  const {
    data: { espAccounts = [] } = {},
    error,
    errorMessage,
    refetch: refetchEspAccountsGraphql,
    isLoading: isLoadingEspAccounts,
  } = useGraphql<FetchEspAccountsResponse>(fetchEspAccountsQuery);
  const dispatch = useDispatch();
  const medium = getMediumByKey(messageMedium);
  const currentAccounts = espAccounts?.filter((account) => {
    // only show espAccounts for email, sms, and whatsapp message types
    switch (medium?.dbKey) {
      case MESSAGE_MEDIUMS.EMAIL.dbKey:
        return EMAIL_SERVICE_PROVIDERS.includes(account.esp);
      case MESSAGE_MEDIUMS.SMS.dbKey:
        return SMS_SERVICE_PROVIDERS.includes(account.esp);
      case WhatsApp:
        return WHATS_APP_SERVICE_PROVIDERS.includes(account.esp);
      default:
        return false;
    }
  });

  const getEspAccountById = (espAccountId: number): EspAccount =>
    espAccounts.find((espAccount) => espAccount.id === espAccountId) as EspAccount;

  useEffect(() => {
    if (error && errorMessage?.message) {
      dispatch(addNegativeToastWithErrorId(errorMessage.message, 'useEspAccounts', errorMessage));
    }
  }, [error]);

  return {
    espAccounts: currentAccounts,
    getEspAccountById,
    refetchEspAccountsGraphql,
    isLoadingEspAccounts,
  };
};
